import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../dashboard/dashboard.module.scss';
import AuthenticationModal from '../../components/popup-modal/authenticationModal';
import LogoutConfirmation from '../../components/popup-modal/logoutPopup';
import userIcon from '../../asserts/images/avatar1.png';
import logoutIcon from '../../asserts/images/logout.jpg';
import SnackbarNotification from '../../components/snackbar-notification/notification'; // Import SnackbarNotification
import { Typography, Box, Paper, Button ,CircularProgress} from '@mui/material';
import logo from '../../asserts/images/napid.png';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateActions } from '../../store/store';
import { logoutUser } from '../../services/loginsApi'; // Import only logoutUser
import CreateSubscriptionModal from './components/subscriptionCreationModal';
import AddMoreIdsModal from './components/addMoreIdsModals'
import AddMoreAppsModal from './components/addMoreAppsModals';
import { createSubscription,} from '../../services/postApis'; // Ensure imports
import {getAllSubscriptions} from '../../services/getApis'; 
import { updateSubscriptionUserCount, updateSubscriptionApplicationCount } from '../../services/putApis';
import NapidAuthAPI from '../../api/napidAuthApi';
import ClientAPI from '../../api/clientApi.mjs';
 
const CreateSubscription = () => {
  const [selectedNav, setSelectedNav] = useState('subscription');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [subscriptionToEdit, setSubscriptionToEdit] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [formType, setFormType] = useState('');
  const [applicationsPopupVisible, setApplicationsPopupVisible] = useState(false);
  const [isLogoutConfirmationOpen, setIsLogoutConfirmationOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userEmail = useSelector((state) => state.auth.userEmailId);
  const { role } = location.state || {};
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [subscriptions, setSubscriptions] = useState([]);
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken);
  const userRole=useSelector((state)=> state.auth.userRole)
  const [loading, setLoading] = useState(true); // Add loading state
 
  // Fetch all subscriptions when the component mounts
  useEffect(() => {
    fetchSubscriptions();
  }, []);
 
  const fetchSubscriptions = async () => {
    setLoading(true); // Set loading to true before fetching
    try {
      const data = await ClientAPI.getAllSubscriptions();
      setSubscriptions(data); // Set fetched data into state
    } catch (error) {
      
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };
 
 
  const handleLogoutClick = () => {
    setIsLogoutConfirmationOpen(true); // Open the logout confirmation popup
  };
 
  const handleLogoutConfirm = async () => {
    setIsLogoutConfirmationOpen(false);
 
    try {
        await NapidAuthAPI.logoutUser(accessToken);      
        localStorage.removeItem('refreshToken');
        dispatch(authenticateActions.logout());
        navigate('/login');
    } catch (error) {
        
    }
};
 
  const handleLogoutCancel = () => {
    setIsLogoutConfirmationOpen(false);
  };
 
  const handleModalOpen = (subscription = null, edit = false) => {
    setSubscriptionData(subscription);
    setIsEdit(edit);
    setIsModalOpen(true);
  };
 
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSubscriptionData(null);
    setIsEdit(false);
  };
 
 
  const handleAuthModalClose = () => {
    setIsAuthModalOpen(false);
    setSubscriptionToEdit(null);
  };
 
  const handleAuthSubmit = () => {
    handleAuthModalClose();
    handleModalOpen(subscriptionToEdit, true);
  };
 
 
  const handleClosePopup = () => {
    setPopupVisible(false);
  };
 
  const handleAddIdsSubmit = async (data) => {
    try {
      // Default subscription ID if missing
      const subscriptionId = subscriptionData?.id || 1; // Default to 1 if the subscription ID is missing
 
      // Ensure newUserCount is defined and valid
      const newUserCount = data.newUserCount; // Extract the new user count from the submitted data
      if (!newUserCount || newUserCount < 1) {
        
        throw new Error('newUserCount must be at least 1');
      }
 
      const userCountData = {
        id: subscriptionId,  // Using "id" for consistency with your API request
        totalNumberOfUser: newUserCount,  // Ensure the key matches your API's expectation
      };
      await fetchSubscriptions();
      handleClosePopup();
    } catch (error) {
      // Handle error
      // showSnackbar(MESSAGES.ERROR.ADD_IDS_FAILED, 'error');
      handleClosePopup();
    }
  };
 
 
  const handleAddMoreAppsSubmit = async ({ subscriptionId, numApps }) => {
    try {
      const applicationData = {
        id: subscriptionId, // Use the subscription ID passed in
        totalNoOfApplication: numApps, // Assuming this is passed correctly
      };
      await ClientAPI.updateSubscriptionApplicationCount(applicationData);
      await fetchSubscriptions();
      handleCloseApplicationsPopup();
    } catch (error) {
     // showSnackbar(MESSAGES.ERROR.ADD_APPLICATIONS_FAILED, 'error');
      handleCloseApplicationsPopup();
    }
  };
 
  const handleCloseApplicationsPopup = () => {
    setApplicationsPopupVisible(false);
  };
   // Handle the submit logic after the subscription form is completed
 
  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
return (
    <div className={styles.dashboardContainer}>
      {/* Container for Logo and Welcome Message */}
      <div className={styles.logoAndMessageContainer}>
        {/* Logo, conditionally hidden */}
       
        <div className={styles.logoContainer}>
            <img src={logo} alt="NAPID Logo" className={styles.logo} />
        </div>
       
        {/* Always display the welcome message */}
        <div className={styles.welcomeMessage1}>
          Welcome {userRole},
        </div>
      </div>
 
      <div className={styles.content}>
        <div className={styles.userInfo}>
          {/* Always display the user icon and email */}
          <img src={userIcon} alt="User Icon" className={styles.userIcon} />
          <span className={styles.userEmail}>{userEmail}</span>
        </div>
 
        <div className={styles.centeredContent}>
          <button
            className={styles.createSubscriptionButton}
            onClick={() => setIsModalOpen(true)} // Open modal to create subscription
          >
            Create Subscription
          </button>
        </div>
 
        <button className={styles.logoutButton} onClick={handleLogoutClick}>
          <img src={logoutIcon} alt="Logout" className={styles.logoutIcon} title="Logout" />
        </button>
 
        {/* You can remove the renderContent function if it only returns the button */}
      </div>
 
        {/* Modal components remain unchanged */}
        <CreateSubscriptionModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          afterSubmit={fetchSubscriptions}
         // onSubmit={handleSubmit} // Handle submission from the new modal
        />
        <LogoutConfirmation
            isOpen={isLogoutConfirmationOpen}
            onClose={handleLogoutCancel}
            onConfirm={handleLogoutConfirm}
            message="Are you sure you want to logout?"
        />
        {/* Other modals */}
        <AddMoreIdsModal
            isOpen={popupVisible}
            onClose={handleClosePopup}
            onSubmit={handleAddIdsSubmit}
            formType={formType}
            afterSubmit={fetchSubscriptions}
            subscriptionData={subscriptionData}
        />
        <AddMoreAppsModal
            isOpen={applicationsPopupVisible}
            onClose={handleCloseApplicationsPopup}
            onSubmit={handleAddMoreAppsSubmit}
            formType="addMoreApps"
            afterSubmit={fetchSubscriptions}
        />
        <AuthenticationModal
            isOpen={isAuthModalOpen}
            onClose={handleAuthModalClose}
            onSubmit={handleAuthSubmit}
        />
        <SnackbarNotification
            open={snackbarOpen}
            handleClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
            severity={snackbarSeverity}
        />
    </div>
);
};
 
export default CreateSubscription;  
 